import React from 'react';
import Button from '../Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import styled from '../styled';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme, props) => ({
  root: {},
  rootPaper: {
    padding: '32px',
  },
  title: {
    padding: '0px',
    margin: '0px',
    fontSize: '24px',
    color: theme.colors.eyConfidentGrey,
  },
  divider: {
    marginTop: '40px',
    height: '1px',
    width: '100%',
    border: '0.5px solid #CCC',
    opacity: '0.7',
  },
  contentRoot: {
    padding: '32px 0px 0px 0px',
  },
  contentText: {
    color: theme.colors.eyConfidentGrey,
    fontSize: '14px',
  },
  actionsRoot: {
    margin: '24px 0px 0px 0px',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '400px',
  },
  buttonAction: {
    margin: '0px 16px 0px 0px',
  },
  closeIcon: {
    cursor: 'pointer',
    height: '24px',
    width: '24px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  primaryBtnRoot: {
    border: '1px solid !important',
    borderColor: theme.colors.eyConfidentGrey,
  },
});

class CustomAlertDialog extends React.Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.refInputs = React.createRef();
  }

  componentDidMount() {
    this.focusTextInput();
  }

  componentDidUpdate() {
    this.focusTextInput();
  }

  focusTextInput = () => {
    // GET DIALOG REFERENCE TO ADD A FOCUS EVENT ON THE FIRST INPUT OR BUTTON
    if (this.refInputs.current) {
      const inputElement = this.refInputs.current.getElementsByTagName('input');
      const firstElement = inputElement.length ? inputElement : this.refInputs.current.getElementsByTagName('button');
      if (firstElement.length) {
        firstElement[0].focus();
      }
    }
  };
  handleOnClose = __callback => {
    if (__callback) {
      __callback(true);
    }
    return;
  };

  render() {
    const {
      cancelText,
      children,
      classes,
      onCancel,
      open,
      title,
      noMaxWidth,
      closeIcon,
      showConfirm,
      confirmText,
      onConfirm,
      showConfirmBtnFirst,
    } = this.props;

    return (
      <Dialog
        classes={{ root: classes.root, paper: classes.rootPaper }}
        open={open}
        aria-labelledby="confirm-title"
        aria-describedby="alert-content"
        role="dialog"
        ref={this.refInputs}>
        <div className={classes.header}>
          <h2 className={classes.title} id="confirm-title">
            {title}
          </h2>
          {closeIcon && (
            <div className={classes.closeIcon} onClick={e => this.handleOnClose(onCancel)}>
              <CloseIcon />
            </div>
          )}
        </div>
        <DialogContent classes={{ root: classes.contentRoot }} id="alert-content">
          <DialogContentText classes={{ root: classes.contentText }}>{children}</DialogContentText>
        </DialogContent>
        <div className={classes.divider} />
        <DialogActions classes={{ root: classes.actionsRoot, action: classes.buttonAction }}>
          {showConfirm && showConfirmBtnFirst && (
            <Button classes={{ root: classes.primaryBtnRoot }} onClick={onConfirm || null} noMaxWidth={noMaxWidth}>
              {confirmText}
            </Button>
          )}

          <Button onClick={onCancel || null} noMaxWidth={noMaxWidth} styleType={'secondary'}>
            {cancelText}
          </Button>

          {showConfirm && !showConfirmBtnFirst && (
            <Button classes={{ root: classes.primaryBtnRoot }} onClick={onConfirm || null} noMaxWidth={noMaxWidth}>
              {confirmText}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}

export default styled(CustomAlertDialog)(styles);
